import "./index.css";
import React from "react";
import { Tooltip } from "antd";

// import React, { useEffect } from "react";
// import { notification, Tooltip } from "antd";
// import { WarningOutlined } from "@ant-design/icons";

// type TypeValue = (typeof OPTIONS)[number]["value"];

// interface TypeModeProps<T extends TypeValue = TypeValue> {
//   bottom: number;
//   left?: number;
//   value: T;
//   onChange(value: T): void;
//   /**
//    * @param isMobile 手机端显示desc
//    */
//   isMobile?: boolean;
//   /**
//    * @param guidelineCount 选中 “guidelines” 的数量
//    * @description 10个guidelines : 可选 instant、deepsearch
//    *              0个guideline  : 应只能应用 deepsearch
//    */
//   guidelineCount: number;
// }

// const OPTIONS = [
//   {
//     label: "Instant",
//     value: "instant",
//   },
//   {
//     label: "DeepSearch",
//     value: "deepthinking",
//   },
// ] as const;

// /**
//  * @name Mode 查询模式
//  * @deprecated 现在全部调整为 “DeepSearch” 模式
//  */
// const Mode: React.FC<TypeModeProps> = ({
//   value,
//   isMobile,
//   onChange,
//   guidelineCount,
// }) => {
//   const EXCEEDING_LIMITS = !guidelineCount || guidelineCount > 10;

//   useEffect(() => {
//     guidelineCount > 10 && onChange("deepthinking");
//   }, [guidelineCount]);

//   function getDeepSearchHint() {
//     if (guidelineCount > 10) {
//       return `You've selected over 10 guidelines. This search will only run in DeepSearch Mode.`;
//     } else if (!guidelineCount) {
//       return `No program or guideline selected. Your query will run in DeepSearch Mode by default.`;
//     } else {
//       return "";
//     }
//   }

//   function onModeChange(value: TypeValue) {
//     onChange(EXCEEDING_LIMITS ? "deepthinking" : value);
//     if (isMobile && EXCEEDING_LIMITS) {
//       notification.open({
//         duration: 2,
//         description: getDeepSearchHint(),
//         message: "Instant search is disabled",
//         icon: <WarningOutlined rev={undefined} />,
//       });
//     }
//   }

//   const DESC = {
//     instant: EXCEEDING_LIMITS ? (
//       <div className="gpt-mode-select-hint">
//         <p>Instant search is disabled</p>
//         <p>{getDeepSearchHint()}</p>
//       </div>
//     ) : (
//       "Fast answers to simple questions"
//     ),
//     deepthinking: "Deep search on any topics",
//   };

//   return (
//     <div className="gpt-mode-select">
//       {OPTIONS.map((v) => (
//         <Tooltip
//           key={v.value}
//           placement="bottom"
//           title={isMobile ? null : DESC[v.value]}
//         >
//           <div
//             onClick={() => onModeChange(v.value)}
//             className={value === v.value ? "gpt-mode-select-checked" : ""}
//           >
//             <span
//               className={
//                 v.value === "instant" && EXCEEDING_LIMITS
//                   ? "gpt-mode-select-disable"
//                   : ""
//               }
//             >
//               {v.label}
//             </span>
//           </div>
//         </Tooltip>
//       ))}
//     </div>
//   );
// };

/**
 * @name Mode 查询模式
 * @description 仅支持 查询模式
 */
const Mode: React.FC<{ paddingLeft?: number }> = ({ paddingLeft = 10 }) => (
  <Tooltip
    placement="bottom"
    title="Deeper guideline search for a more accurate answer."
  >
    <span className="deep-search-mode" style={{ paddingLeft }}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="10"
        height="15"
        viewBox="0 0 10 15"
        fill="none"
      >
        <path
          d="M6.75 8.75C6.88333 8.08333 7.21667 7.61667 7.75 7.08333C8.41667 6.48333 8.75 5.61667 8.75 4.75C8.75 3.68913 8.32857 2.67172 7.57843 1.92157C6.82828 1.17143 5.81087 0.75 4.75 0.75C3.68913 0.75 2.67172 1.17143 1.92157 1.92157C1.17143 2.67172 0.75 3.68913 0.75 4.75C0.75 5.41667 0.883333 6.21667 1.75 7.08333C2.21667 7.55 2.61667 8.08333 2.75 8.75M2.75 11.4167H6.75M3.41667 14.0833H6.08333"
          stroke="#9F9F9F"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
      <span>DeepSearch</span>
    </span>
  </Tooltip>
);

export default Mode;
